import { IPicture } from "../models";

/** pictures.difficulty (1–4). Keep in sync with PictureDifficulty in ProductsController. */
export enum Difficulty {
  Lako = 1,
  SrednjeLako = 2,
  Tesko = 3,
  VeomaTesko = 4,
}

export interface IDifficultyLevel {
  value: Difficulty;
  label: string;
  description: string;
}

export const DIFFICULTY_LEVELS: IDifficultyLevel[] = [
  {
    value: Difficulty.Lako,
    label: "Lako",
    description: "Pogodno za početnike – veće površine i manje sitnih detalja.",
  },
  {
    value: Difficulty.SrednjeLako,
    label: "Srednje lako",
    description: "Umeren izazov – kombinacija većih i manjih površina.",
  },
  {
    value: Difficulty.Tesko,
    label: "Teško",
    description: "Mnogo manjih površina i detalja koji zahtevaju preciznost.",
  },
  {
    value: Difficulty.VeomaTesko,
    label: "Veoma teško",
    description:
      "Veoma detaljne slike koje zahtevaju dosta strpljenja i preciznosti.",
  },
];

/** undefined when the picture has no (valid) difficulty set */
export const getDifficultyLevel = (
  value?: number | null
): IDifficultyLevel | undefined =>
  DIFFICULTY_LEVELS.find((l) => l.value === value);

/** "Težina" filter: nothing selected = everything; otherwise pictures without a level drop out. */
export const matchesDifficulty = (pic: IPicture, filter: Difficulty[]) =>
  filter.length === 0 || (!!pic.difficulty && filter.includes(pic.difficulty));
